import { useAudioPlayer } from "./hooks";
import cls from "./styles.module.css";
import cn from "clsx";
import type { CSSProperties } from "react";

type TProps = {
  className?: string;
};
export default function HeaderSoundPlayer(props: TProps) {
  const { togglePlay, isPlaying } = useAudioPlayer();
  const title = isPlaying ? "Отключить пение птиц" : "Включить пение птиц";
  return (
    <button
      type="button"
      aria-label={title}
      title={title}
      onClick={togglePlay}
      className={cn(cls.root, props.className)}
      style={
        {
          "--pulse-opacity": isPlaying ? "1" : "0",
        } as CSSProperties
      }
    >
      <span className={cls.pivot} />
      <span className={cls.pulse} />
      <span className={cls.pulse} />
    </button>
  );
}
